(function () {
  if (window.__bsInit) return;
  window.__bsInit = true;

  function moneyFormatFallback(value) {
    return value;
  }

  function initSection(section) {
    var track = section.querySelector('[data-bs-track]');
    var prev = section.querySelector('[data-bs-prev]');
    var next = section.querySelector('[data-bs-next]');
    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.bs-card');
      if (!card) return 320;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 20;
      return card.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();

    section.querySelectorAll('[data-bs-card]').forEach(function (card) {
      var atc = card.querySelector('[data-bs-atc]');
      var label = card.querySelector('[data-bs-atc-label]');
      var priceEl = card.querySelector('[data-bs-price]');
      var compareEl = card.querySelector('[data-bs-compare]');
      var imageEl = card.querySelector('[data-bs-image]');
      var defaultLabel = label ? label.textContent : 'Add to cart';

      card.querySelectorAll('[data-bs-swatch]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          card.querySelectorAll('[data-bs-swatch]').forEach(function (s) {
            s.classList.remove('is-active');
          });
          swatch.classList.add('is-active');

          var variantId = swatch.getAttribute('data-variant-id');
          if (variantId) card.setAttribute('data-variant-id', variantId);

          if (priceEl && swatch.dataset.price) {
            priceEl.textContent = swatch.dataset.price;
          }
          if (compareEl) {
            if (swatch.dataset.compare) {
              compareEl.textContent = swatch.dataset.compare;
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
          if (imageEl && swatch.dataset.image) {
            imageEl.src = swatch.dataset.image;
          }
          if (atc) {
            atc.disabled = swatch.getAttribute('data-available') === 'false';
          }
        });
      });

      if (!atc) return;

      atc.addEventListener('click', function () {
        var id = card.getAttribute('data-variant-id');
        if (!id || atc.disabled) return;

        atc.classList.add('is-loading');
        if (label) label.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: Number(id), quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add failed');
            return res.json();
          })
          .then(function () {
            if (label) label.textContent = 'Added';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (typeof window.publish === 'function') {
              window.publish('cart-update');
            }
            setTimeout(function () {
              if (label) label.textContent = defaultLabel;
              atc.classList.remove('is-loading');
            }, 1200);
          })
          .catch(function () {
            if (label) label.textContent = 'Try again';
            atc.classList.remove('is-loading');
            setTimeout(function () {
              if (label) label.textContent = defaultLabel;
            }, 1500);
          });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bs-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      var section = event.target.querySelector('[data-bs-section]') || event.target.closest('[data-bs-section]');
      if (section) initSection(section);
      else if (event.target.matches && event.target.matches('[data-bs-section]')) initSection(event.target);
    }
  });
})();
